import { getTelegramIcon, getViberIcon } from '@/composables/chat'
import Vue from 'vue'
import ToastificationContent from '@/core/components/toastification/ToastificationContent.vue'
import ToastificationOnlineAppointment from '@/views/components/toasts/ToastificationOnlineAppointment.vue'
import ToastificationCustom from '@/views/components/toasts/ToastificationCustom.vue'
import ToastificationNewLead from '@/views/components/toasts/ToastificationNewLead.vue'
import ToastificationPatientProcessedAppointmentNotification
    from '@/views/components/toasts/ToastificationPatientProcessedAppointmentNotification.vue'
import ToastificationNewAct from '@/views/components/toasts/ToastificationNewAct.vue'
import router from '@/router'
import appConstants from '@/constants/constants'
import useMimirman from '@/composables/mimirman'
import ToastificationPatientCameInToAppointmentNotification
  from '@/views/components/toasts/ToastificationPatientCameInToAppointmentNotification.vue'
import ToastificationAuthError from '@/views/components/toasts/ToastificationAuthError.vue'

export const showCommonToast = (
  title, text, variant, listeners = {}, options = {}, icon = 'BellIcon'
) => showToast(ToastificationContent, {title, text, variant, icon}, listeners, options)

export const showInfoOperationEternalToast = (text, title = 'Внимание!') => showToast(
  ToastificationContent,
  {text, title, variant: 'info', icon: 'InfoIcon'},
  {},
  {closeOnClick: true, timeout: false}
)

export const showInfoOperationToast = (text, title = 'Внимание!') => showToast(
  ToastificationContent,
  {text, title, variant: 'info', icon: 'InfoIcon'},
  {},
  {}
)

export const showFailedOperationEternalToast = (text, title = 'Операция не выполнена') => showToast(
  ToastificationContent,
  {text, title, variant: 'danger', icon: 'InfoIcon'},
  {},
  {closeOnClick: true, timeout: false}
)

export const showFailedOperationToast = (
  text, title = 'Операция не выполнена', icon = 'InfoIcon'
) => showToast(
  ToastificationContent,
  {text, title, variant: 'danger', icon: icon},
  {},
  {timeout: 4000}
)

export const showSuccessOperationEternalToast = (
  text, title = 'Операция выполнена', icon = 'BellIcon'
) => showToast(
  ToastificationContent,
  {text, title, variant: 'success', icon: icon},
  {},
  {closeOnClick: true, timeout: false}
)

export const showSuccessOperationToast = (
  text, title = 'Операция выполнена', icon = 'BellIcon'
) => showToast(
  ToastificationContent,
  { text, title, variant: 'success', icon },
  {},
  { timeout: 4000 }
)

export const showWarningOperationToast = (
  text, title = 'Внимание!', icon = 'BellIcon', options = {}
) => showToast(
  ToastificationContent,
  {text, title, variant: 'warning', icon: icon},
  {},
  {timeout: 4000, ...options}
)

export const showWarningOperationEternalToast = (
  text, title = 'Внимание!', icon = 'BellIcon', options = {}
) => showToast(
  ToastificationContent,
  { text, title, variant: 'warning', icon },
  {},
  { closeOnClick: true, timeout: false, ...options }
)

export const showAuthErrorToast = (text, statusCode) => showToast(
  ToastificationAuthError,
  { text, icon: 'InfoIcon', statusCode },
  {},
  { closeOnClick: true, timeout: false, position: 'top-center' }
)

export const showInactiveSessionToast = reason => {
  let text = 'Пожалуйста, войдите в систему заново'
  text = reason === appConstants.auth.logoutReason.INACTIVE_SESSION
    ? `Вы долго не проявляли активность, поэтому мы завершили сеанс. ${text}.` : text
  showToast(
    ToastificationContent,
    { text, title: 'Время сессии истекло', variant: 'warning', icon: 'ClockIcon' },
    {},
    { closeOnClick: true, timeout: false, position: 'top-center' }
  )
}

export const showOnlineAppointmentToast = data => showToast(
  ToastificationOnlineAppointment,
  {
    title: data.title,
    serviceName: data.service_name,
    patientId: data.patient_id,
    doctorFullName: data.doctor_full_name,
    patientFullName: data.patient_full_name,
    patientPhoneCode: data.patient_phone_code,
    patientPhoneNumber: data.patient_phone_number,
    time: data.time,
    variant: 'info',
    icon: 'GlobeIcon'
  },
  {},
  {closeOnClick: true, timeout: false}
)

export const showNewMessageToast = (title, text) => showToast(
  ToastificationContent,
  { title, text, variant: 'info', icon: 'MessageSquareIcon' },
  {},
  { timeout: false }
)

export const showTelegramToast = (title, text) => showToast(
  ToastificationContent,
  { title, text, variant: 'info', customIconSrc: getTelegramIcon() },
  {},
  { timeout: false }
)

export const showMimirmanToast = text => showToast(
  ToastificationContent,
  {
    title: useMimirman().mimirmanLabel,
    text,
    variant: 'light-secondary',
    customIconSrc: useMimirman().mimirmanLogoSrc,
    class: 'mimirman'
  },
  {
    'click-toast': () => {
      if (router.currentRoute.name !== appConstants.router.chat.APP_MIMIRMAN_CHAT) {
        router.push({ name: appConstants.router.chat.APP_MIMIRMAN_CHAT })
      }
    }
  },
  { timeout: false }
)

export const showViberToast = (title, text) => showToast(
  ToastificationContent,
  { title, text, variant: 'primary', customIconSrc: getViberIcon() },
  {},
  { timeout: false }
)

export const showCenteredToast = (
  title, text, files = [], listeners = {}, options = {}
) => showToast(
  ToastificationCustom,
  {
    title: title,
    text: text,
    files: files
  },
  listeners,
  options
)

export const showNewLeadToast = (
  id, date, source, patientFullName, phoneCode, phone, time, chatId, listeners = {}, options = {}
) => showToast(
  ToastificationNewLead,
  {id, date, source, patientFullName, phoneCode, phone, time, chatId},
  listeners,
  options
)

export const showNewActToast = (
  text, actNumber, paymentId, paymentDate, listeners = {}, options = {}
) => showToast(
  ToastificationNewAct,
  { text, actNumber, paymentId, paymentDate },
  listeners,
  options
)

export const showPatientProcessedAppointmentToast = (
  appointmentId, title, patientId, patientFullName, phoneCode, phone, note, rate, appointmentDate, action,
  listeners = {}, options = {}
) => showToast(
  ToastificationPatientProcessedAppointmentNotification,
  {appointmentId, title, patientId, patientFullName, phoneCode, phone, note, rate, appointmentDate, action},
  listeners,
  options
)

export const showPatientCameInToAppointmentToast = (
  appointmentId, title, patientId, patientFullName, phoneCode, phone, appointmentDate, listeners = {},
  options = {}
) => showToast(
  ToastificationPatientCameInToAppointmentNotification,
  { appointmentId, title, patientId, patientFullName, phoneCode, phone, appointmentDate },
  listeners,
  options
)

export const showToast = (component, props = {}, listeners = {}, options = {}) => {
  Vue.$toast({component, props, listeners}, options)
}